import React from "react";
import PropTypes from "prop-types";
import { getSampleDetailsSectionUrl } from "../../../../util";
import AnalysisTableRow from "../../AnalysisTableRow";
import { INTEGRATION_ANALYSIS_METHOD } from "../../consts";
import { prepareHelpMessage } from "../utils";
import { prepareCapeResult } from "./utils";

const CapeTableRow = ({
  capeData,
  resultCape,
  sha1,
  sourceID,
  handleAction
}) => {
  const {
    isProcessing,
    isConfigured,
    fileTypeSupported,
    fileOversized,
    neverSubmitted,
    last_completed_on,
    errorMessage
  } = capeData || {};

  const {
    CAPE: { ICON, TITLE, SHORT_NAME }
  } = INTEGRATION_ANALYSIS_METHOD;

  return (
    <AnalysisTableRow
      icon={ICON}
      title={TITLE}
      shortName={SHORT_NAME}
      isProcessing={isProcessing}
      isConfigured={isConfigured}
      fileTypeSupported={fileTypeSupported}
      fileOversized={fileOversized}
      neverSubmitted={neverSubmitted}
      lastAnalysisTime={last_completed_on}
      result={prepareCapeResult(resultCape)}
      helpMessage={prepareHelpMessage(capeData)}
      errorMessage={errorMessage}
      handleAction={() => handleAction(SHORT_NAME, TITLE)}
      noImpactOnClassification
      reportUrl={getSampleDetailsSectionUrl(SHORT_NAME, null, sha1, sourceID)}
    />
  );
};

CapeTableRow.propTypes = {
  capeData: PropTypes.shape({
    isProcessing: PropTypes.bool,
    isConfigured: PropTypes.bool,
    fileTypeSupported: PropTypes.bool,
    fileOversized: PropTypes.bool,
    neverSubmitted: PropTypes.bool,
    last_completed_on: PropTypes.string,
    errorMessage: PropTypes.string
  }).isRequired,
  resultCape: PropTypes.arrayOf(PropTypes.object).isRequired,
  sha1: PropTypes.string.isRequired,
  sourceID: PropTypes.number.isRequired,
  handleAction: PropTypes.func
};

export default CapeTableRow;
